import { getGiftcardData } from "api";
import { useEffect, useState } from "react";
import { formatNumberWithCommas } from "functions";
import { useSearchParams } from "react-router-dom";
import BarChart from "./BarChart";
import Giftcard from "./Giftcard";
import GiftcardModal from "./GiftcardModal";

function GiftcardDash() {
  const [chartData, setChartData] = useState();
  const [giftCards, setGiftcards] = useState();
  const [total, setTotal] = useState();
  const [selectedCard, setSelectedCard] = useState(null);
  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    const loadData = async () => {
      const loadedData = await getGiftcardData();
      const { data, totalAmount, recentItems } = loadedData;
      setChartData(data);
      setGiftcards(recentItems);
      setTotal(totalAmount);
    };

    loadData();
  }, []);

  const navigateToAll = () => {
    searchParams.set("body", "giftcards");
    setSearchParams(searchParams);
  };

  return (
    <>
      <div
        className="dash-item"
        style={{ paddingBlock: "24px", paddingInline: "28px" }}
      >
        <div className="connection-line giftcard-connection"> </div>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <h2> Giftcards </h2>
          <div className="giftcard-total">
            <span className="white small"> Total Sold: </span>
            <strong className="white"> ${formatNumberWithCommas(total)} </strong>
          </div>
        </div>
        <div className="bar-wrapper">
          {chartData && <BarChart data={chartData} />}
        </div>
      </div>

      <div
        className="dash-item"
        style={{ paddingBlock: "24px", paddingInline: "0px" }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
            paddingInline: "28px",
          }}
        >
          <h2> Recently Purchased </h2>
          <button
            className="new-payroll edit-employees"
            style={{ width: "auto", padding: "8px 14px" }}
            onClick={navigateToAll}
          >
            <span className="white small"> See All </span>
          </button>
        </div>

        <div className="bar-wrapper" style={{ paddingTop: "20px", height: "auto" }}>
          {giftCards && giftCards.map((obj) => (
            <Giftcard
              key={obj._id}
              giftcardObj={obj}
              onClick={() => setSelectedCard(obj)}
            />
          ))}
        </div>
      </div>

      {selectedCard && (
        <GiftcardModal
          giftcard={selectedCard}
          onClose={() => setSelectedCard(null)}
        />
      )}
    </>
  );
}

export default GiftcardDash;
